



































import {Vue, Component, Prop, Emit} from 'nuxt-property-decorator'
import sanitize from 'sanitize-html'

import AutocompleteArticle from '@/components/AutocompleteArticle.vue'
import { FileUpload } from '@frontend/components'
import LayoutSelect from '../components/LayoutSelect.vue'
import { presentArticleData } from '../helpers'

// TODO: refactor into @components
const extractAttr = (s: string, attr: string) => {
  const start = s.slice(s.search(`${attr}="`)).slice(attr.length + 2)
  return start.slice(0, start.search(/["]/g))
}

@Component({
  components: {
    AutocompleteArticle,
    FileUpload,
    LayoutSelect,
  }
})
export default class SpotlightLayout extends Vue {
  @Prop({type: Object, required: true})
  layout: { spotlight: any, chartOfTheWeek: any, spotlightJr: any }

  @Prop({type: Boolean, default: false})
  highlightFields: boolean

  @Prop({type: String})
  readonly draftId: string | null

  disableWithoutImage (article) {
    return !article.image
  }

  url = process.env.VUE_APP_API_ENDPOINT || ''

  headers = {
    Authorization: 'Bearer ' + this.$login.getToken(),
  }

  get spotlightTitle() {
    console.log(this.layout?.spotlight?.article)
    return this.layout?.spotlight?.article?.title || ''
  }

  get spotlightJrTitle() {
    return this.layout?.spotlightJr?.article?.title || ''
  }

  @Emit('update')
  selectedArticle(article) {
    console.log(article, presentArticleData(article))
    return {
      spotlight: {
        ...this.layout.spotlight,
        ...presentArticleData(article)
      }
    }
  }

  @Emit('update')
  selectedJrArticle(article) {
    return {
      spotlightJr: {
        ...this.layout.spotlightJr,
        ...presentArticleData(article)
      }
    }
  }

  @Emit('update')
  updateChartOfTheWeekContent(content) {
    // const html = sanitize(value, {
    //   allowedTags: ['iframe'],
    //   allowedAttributes: {iframe: ['src']},
    // })

    // const src = extractAttr(html, 'src')

    // return {
    //   /* eslint-disable */
    //   chartOfTheWeek: {
    //     content: `<div class="cotw-frame-container">
    //       <iframe src="${src}"></iframe>
    //     </div>
    //     `,
    //   }
    //   /* eslint-enable */
    // }

    return {
      chartOfTheWeek: {
        content,
      }
    }
  }
}
